module.exports = __webpack_public_path__ + "static/media/strategy1.d8aa1139.avif";